import React from 'react';
import { toast } from 'react-toastify';

import { Button, TextField, Typography } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Autocomplete } from '@material-ui/lab';
import { isNull, isArray, isEmpty, includes, assign } from 'lodash';

import { Modal } from '~/components';
import { t, number } from '~/helpers';
import api from '~/services/api';

import { Form, Tabela } from './components';
import operator from './operator';
import * as S from './styles';

/**
 * LEGENDA
 * (1) Turno aberto, (2) Turno fechado, (3) Transferência de turno.
 */

export default function OperacaoTurno() {
  const [monitorStatus, setMonitorStatus] = React.useState(false);

  const [load, setLoad] = React.useState(false);
  const [shift, setShift] = React.useState(null);
  const [tanks, setTanks] = React.useState([]);
  const [opening, setOpening] = React.useState(operator);
  const [closure, setClosure] = React.useState(operator);
  const [posto, setPosto] = React.useState(0);
  const [transfer, setTransfer] = React.useState({});
  const [tabelas, setTabelas] = React.useState({});
  const [bicos, setBicos] = React.useState([]);
  const [estoques, setEstoques] = React.useState([]);
  const [estoquesAreia, setEstoquesAreia] = React.useState([]);

  // Controle 20
  const [tipoControle, setTipoControle] = React.useState(10);
  const [controla20grausposto, setControla20grausposto] = React.useState(null);

  const modalRef = React.useRef(null);

  // Check block buttons
  const isBlock = React.useMemo(() => Boolean(load || isNull(shift)), [
    load,
    shift,
  ]);

  // Label button turn
  const labelButton = React.useMemo(() => {
    if (shift === 2) return t('s.operacao.turno.abrirturno');
    if (shift === 3) return t('s.operacao.turno.transferir');

    return t('s.operacao.turno.fecharturno');
  }, [shift]);

  // Text view
  const textView = React.useMemo(() => {
    if (includes([1, 3], shift)) return t('s.operacao.turno.turnoaberto');
    if (shift === 2) return t('s.operacao.turno.turnofechado');

    return '';
  }, [shift]);

  // Closing column heads
  const cellClosing = React.useMemo(
    () => [
      { id: 'idbico', label: t('s.operacao.turno.biconumero') },
      { id: 'nomeabreviadoproduto', label: t('s.menu.configuracao.produto') },
      {
        id: 'mecanicoinicioturnobico',
        label: t('s.operacao.turno.encerrantemecanicoinicial'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'eletronicofimturnobico',
        label: t('s.operacao.turno.encerranteatual'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'diferenca',
        label: t('s.operacao.turno.diferenca'),
        align: 'right',
        format: (value) => number(value, 2),
      },
    ],
    [t]
  );

  // Stock column heads
  const cellStock = React.useMemo(
    () => [
      { id: 'codigotanquefisico', label: t('s.operacao.turno.tanque') },
      { id: 'nomeabreviadoproduto', label: t('s.menu.configuracao.produto') },
      {
        id: 'volmedidoinicioturnotanque',
        label: t('s.operacao.turno.volinicontabil'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volrecebidoturnotanque',
        label: t('s.operacao.turno.recebimentodescarga'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'voldrenoturnotanque',
        label: t('s.operacao.turno.dreno'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volabastturnotanque',
        label: t('s.operacao.turno.abastecimentos'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volvazturnotanque',
        label: t('s.operacao.turno.vazaona'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volintransfturnotanque',
        label: t('s.operacao.turno.recebimentotrans'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volouttransfturnotanque',
        label: t('s.operacao.turno.saidatrans'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      /* {
        id: 'volinbombturnotanque',
        label: t('s.operacao.turno.entradabombeamento'),
        align: 'right',
      },
      {
        id: 'voloutbombturnotanque',
        label: t('s.operacao.turno.saidabombeamento'),
        align: 'right',
      }, */
      {
        id: 'volumefinal',
        label: t('s.operacao.turno.volfimcontabil'),
        align: 'right',
        format: (value) => number(value, 1),
      },
    ],
    [t]
  );

  // Stock column heads cellStock20
  const cellStock20 = React.useMemo(
    () => [
      { id: 'codigotanquefisico', label: t('s.operacao.turno.tanque') },
      { id: 'nomeabreviadoproduto', label: t('s.menu.configuracao.produto') },
      {
        id: 'volmedido20inicioturnotanque',
        label: t('s.operacao.turno.volinicontabil'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volrecebido20turnotanque',
        label: t('s.operacao.turno.recebimentodescarga'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'voldrenoturnotanque',
        label: t('s.operacao.turno.dreno'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volabast20turnotanque',
        label: t('s.operacao.turno.abastecimentos'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volvaz20turnotanque',
        label: t('s.operacao.turno.vazaona'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volintransf20turnotanque',
        label: t('s.operacao.turno.recebimentotrans'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      {
        id: 'volouttransf20turnotanque',
        label: t('s.operacao.turno.saidatrans'),
        align: 'right',
        format: (value) => number(value, 1),
      },
      /* {
        id: 'volinbombturnotanque',
        label: t('s.operacao.turno.entradabombeamento'),
        align: 'right',
      },
      {
        id: 'voloutbombturnotanque',
        label: t('s.operacao.turno.saidabombeamento'),
        align: 'right',
      }, */
      {
        id: 'volume20final',
        label: t('s.operacao.turno.volfimcontabil'),
        align: 'right',
        format: (value) => number(value, 1),
      },
    ],
    [t]
  );

  // Sand stock column heads
  const cellEstoqueAreia = React.useMemo(
    () => [
      { id: 'descricaoareia', label: t('s.cadastro.pitstop.tipoareia') },
      { id: 'origemareia', label: 'Origem' },
      {
        id: 'quantidadeaberturaturnoestoqueareiaitem',
        label: 'Inicio (Qtde)',
        align: 'right',
        format: (value) => number(value, 0),
      },
      {
        id: 'estoquekgaberturaturnoestoqueareiaitem',
        label: 'Inicio (kg)',
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'quantidadeatualturnoestoqueareiaitem',
        label: 'Atual (Qtde)',
        align: 'right',
        format: (value) => number(value, 0),
      },
      {
        id: 'estoquekgatualturnoestoqueareiaitem',
        label: 'Atual (kg)',
        align: 'right',
        format: (value) => number(value, 2),
      },
    ],
    [t]
  );

  // Reset vars
  const handleResetVars = React.useCallback(() => {
    setOpening(operator);
    setClosure(operator);
    setBicos([]);
    setEstoques([]);
    setEstoquesAreia([]);
    setTabelas({});
  }, []);

  // Load tanks
  const handleGetTanks = React.useCallback(async () => {
    const params = { pagesize: 9999 };

    setLoad(true);

    try {
      const { data } = await api.get('postos', {
        params: { pesquisalista: true, ...params },
      });
      setTanks(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  // Loading data to fill the tables
  const handleGetDataTable = React.useCallback(async (id, codeTransfer) => {
    try {
      const { data } = await api.get(`turnos/${id}`);

      if (!data?.idturno) {
        setShift(2);
        handleResetVars();
        return;
      }

      setTabelas(data);

      setOpening({
        date: data.datahorainicialturno,
        operator: isNull(data.codigousuarioinicialturno)
          ? ''
          : `${data.codigousuarioinicialturno} - ${data.nomeusuarioinicialturno}`,
        description: data.observacaoinicioturno,
      });

      setClosure({
        date: data.datahorafinalturno,
        operator: isNull(data.codigousuariofinalturno)
          ? ''
          : `${data.codigousuariofinalturno} - ${data.nomeusuariofinalturno}`,
        description: data.observacaofimturno,
      });
      setBicos(
        (data?.bicos ?? []).map((bico) => ({
          ...bico,
          mecanicoinicioturnobico: bico.mecanicoinicioturnobico,
          eletronicofimturnobico: bico.eletronicofimturnobico,
          diferenca: bico.diferenca,
        }))
      );

      setEstoques(
        (data?.tanques ?? []).map((tanque) => ({
          ...tanque,
          volmedidoinicioturnotanque: tanque.volmedidoinicioturnotanque,
          volrecebidoturnotanque: tanque.volrecebidoturnotanque,
          voldrenoturnotanque: tanque.voldrenoturnotanque,
          volabastturnotanque: tanque.volabastturnotanque,
          volvazturnotanque: tanque.volvazturnotanque,
          volintransfturnotanque: tanque.volintransfturnotanque,
          volouttransfturnotanque: tanque.volouttransfturnotanque,
          volinbombturnotanque: tanque.volinbombturnotanque,
          voloutbombturnotanque: tanque.voloutbombturnotanque,
          volumefinal: tanque.volumefinal,

          volrecebido20turnotanque: tanque.volrecebido20turnotanque,
          volabast20turnotanque: tanque.volabast20turnotanque,
          volvaz20turnotanque: tanque.volvaz20turnotanque,
          volintransf20turnotanque: tanque.volintransf20turnotanque,
          volouttransf20turnotanque: tanque.volouttransf20turnotanque,
          volinbomb20turnotanque: tanque.volinbomb20turnotanque,
          voloutbomb20turnotanque: tanque.voloutbomb20turnotanque,
          volcomplemento20turnotanque: tanque.volcomplemento20turnotanque,
          volcontabil20fimturnotanque: tanque.volcontabil20fimturnotanque,
          volmedido20inicioturnotanque: tanque.volmedido20inicioturnotanque,
          volmedido20fimturnotanque: tanque.volmedido20fimturnotanque,

          volume20final: tanque.volume20final,
        }))
      );

      setEstoquesAreia(
        (data?.estoqueAreia?.itens ?? []).map((item) => ({
          ...item,
          descricaoareia: item.descricaotipoareia,
          origemareia:
            item.silotipoareia === 'S'
              ? item.nomepostotipoareia || 'Silo'
              : 'Saco',
        }))
      );

      // setBicos(
      //   data.bicos.map((bico) => ({
      //     ...bico,
      //     mecanicoinicioturnobico: bico.mecanicoinicioturnobico, // number(bico.mecanicoinicioturnobico, 1),
      //     eletronicofimturnobico: bico.eletronicofimturnobico, // number(bico.eletronicofimturnobico, 1),
      //     diferenca: bico.diferenca, // number(bico.diferenca, 1),
      //   }))
      // );

      // setEstoques(
      //   data.tanques.map((tanque) => ({
      //     ...tanque,
      //     volmedidoinicioturnotanque: tanque.volmedidoinicioturnotanque, // number(tanque.volmedidoinicioturnotanque, 1),
      //     volrecebidoturnotanque: tanque.volrecebidoturnotanque, // number(tanque.volrecebidoturnotanque, 1),
      //     voldrenoturnotanque: tanque.voldrenoturnotanque, // number(tanque.voldrenoturnotanque, 1),
      //     volabastturnotanque: tanque.volabastturnotanque, // number(tanque.volabastturnotanque, 1),
      //     volvazturnotanque: tanque.volvazturnotanque, // number(tanque.volvazturnotanque, 1),
      //     volintransfturnotanque: tanque.volintransfturnotanque, // number(tanque.volintransfturnotanque, 1),
      //     volouttransfturnotanque: tanque.volouttransfturnotanque, // number(tanque.volouttransfturnotanque, 1),
      //     volinbombturnotanque: tanque.volinbombturnotanque, // number(tanque.volinbombturnotanque, 1),
      //     voloutbombturnotanque: tanque.voloutbombturnotanque, // number(tanque.voloutbombturnotanque, 1),
      //     volumefinal: tanque.volumefinal, // number(tanque.volumefinal, 1),

      //     volrecebido20turnotanque: tanque.volrecebido20turnotanque, // number(tanque.volrecebido20turnotanque, 1),
      //     volabast20turnotanque: tanque.volabast20turnotanque, // number(tanque.volabast20turnotanque, 1),
      //     volvaz20turnotanque: tanque.volvaz20turnotanque, // number(tanque.volvaz20turnotanque, 1),
      //     volintransf20turnotanque: tanque.volintransf20turnotanque, // number(tanque.volintransf20turnotanque, 1),
      //     volouttransf20turnotanque: tanque.volouttransf20turnotanque, // number(tanque.volouttransf20turnotanque, 1),
      //     volinbomb20turnotanque: tanque.volinbomb20turnotanque, // number(tanque.volinbomb20turnotanque, 1),
      //     voloutbomb20turnotanque: tanque.voloutbomb20turnotanque, // number(tanque.voloutbomb20turnotanque, 1),
      //     volcomplemento20turnotanque: tanque.volcomplemento20turnotanque, // number(tanque.volcomplemento20turnotanque, 1),
      //     volcontabil20fimturnotanque: tanque.volcontabil20fimturnotanque, // number(tanque.volcontabil20fimturnotanque, 1),
      //     volmedido20inicioturnotanque: tanque.volmedido20inicioturnotanque, // number(tanque.volmedido20inicioturnotanque, 1),
      //     volmedido20fimturnotanque: tanque.volmedido20fimturnotanque, // number(tanque.volmedido20fimturnotanque, 1),

      //     volume20final: tanque.volume20final, // number(tanque.volume20final, 1),
      //   }))
      // );

      if (codeTransfer === 1) setShift(3);
      else setShift(isEmpty(data.datahorafinalturno) ? 1 : 2);
    } catch (err) {
      console.log(err);

      if (Array.isArray(err)) {
        err.forEach(e => e && toast.error(t(e)));
      } else if (err) {
        toast.error(t(err));
      }

      setShift(2);
      handleResetVars();
    }
  }, []);

  // Change autocomplete
  const handleChangeAutocomplete = React.useCallback(
    (value) => {
      if (isNull(value)) {
        setControla20grausposto(null);
        setTipoControle(10);
        setShift(null);
        handleResetVars();
      } else {
        const {
          idposto,
          transfereturnoposto,
          controla20grausposto,
          operrecebimento20posto,
        } = value;

        // console.log(JSON.stringify({ value }, null, 2));

        setPosto(idposto);
        setTransfer(value);
        setControla20grausposto(controla20grausposto && operrecebimento20posto);

        setTipoControle(10);

        handleGetDataTable(idposto, transfereturnoposto);
      }
    },
    [posto]
  );

  // Open Modal
  const handleOpenModal = React.useCallback(() => {
    const tabelasData = assign({}, tabelas);

    /*
    if (shift === 2) {
      tabelasData.bicos = [];
      tabelasData.tanques = [];
    } */

    modalRef.current.handleOpenModal({
      posto: transfer,
      tabelas: tabelasData,
      type: shift,
    });
  }, [tabelas, transfer, shift]);

  // Calback close modal
  const handleCallbackOnCloseModal = React.useCallback(async (values) => {
    const { idposto, transfereturnoposto } = values.posto;

    await handleResetVars();
    await handleGetDataTable(idposto, transfereturnoposto);
  }, []);

  // Initial data
  React.useEffect(() => {
    handleGetTanks();
  }, []);

  // Autoload
  React.useEffect(() => {
    if (posto !== 0) {
      const timeOut = setInterval(() => {
        if (!monitorStatus) {
          // console.log("monitor false")
          handleGetDataTable(posto, transfer.transfereturnoposto);
        } else {
          // console.log("monitor true")
        }
      }, 30000);

      return () => clearInterval(timeOut);
    }
  }, [posto, transfer, monitorStatus]);

  const handleChangeTipoControle = React.useCallback(async (event) => {
    setTipoControle(Number(event.target.value));
  }, []);

  return (
    <S.Wrapper>
      <S.WrapperGroupText>
        <S.WrapperHeader>
          <Autocomplete
            options={tanks}
            getOptionLabel={({ codigonomeposto }) => codigonomeposto}
            onChange={(e, value) => handleChangeAutocomplete(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('s.operacao.turno.posto')}
                variant="outlined"
                size="small"
              />
            )}
          />

          <Typography>{textView}</Typography>
        </S.WrapperHeader>

        <Button
          size="small"
          variant="outlined"
          color="primary"
          disabled={isBlock}
          onClick={handleOpenModal}
        >
          {labelButton}
        </Button>
      </S.WrapperGroupText>

      <S.WrapperInputs>
        <S.WrapperTitle>{t('s.operacao.turno.abertura')}</S.WrapperTitle>

        <S.WrapperGroupInput>
          <TextField
            disabled
            label={t('s.operacao.turno.datahora')}
            size="small"
            variant="outlined"
            value={opening.date}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label={t('s.operacao.turno.operador')}
            size="small"
            variant="outlined"
            value={opening.operator}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label={t('s.operacao.turno.observacao')}
            size="small"
            variant="outlined"
            value={opening.description}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </S.WrapperGroupInput>

        <S.WrapperTitle>{t('s.operacao.turno.fechamento')}</S.WrapperTitle>

        <S.WrapperGroupInput>
          <TextField
            disabled
            label={t('s.operacao.turno.datahora')}
            size="small"
            variant="outlined"
            value={closure.date}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label={t('s.operacao.turno.operador')}
            size="small"
            variant="outlined"
            value={closure.operator}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label={t('s.operacao.turno.observacao')}
            size="small"
            variant="outlined"
            value={closure.description}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </S.WrapperGroupInput>
      </S.WrapperInputs>

      <S.WrapperGrid>
        <Tabela
          title={t('s.operacao.turno.encerrantesbicos')}
          cells={cellClosing}
          data={bicos}
          size="small"
        />

        {/** Para escolher o tipo de visualização  */}
        {controla20grausposto ? (
          <S.Wrapper>
            <S.WrapperHeader>
              <S.WrapperSelect>
                <S.WrapperFormControl>
                  <InputLabel htmlFor="tipoControle-simple">
                    Tipo Controle
                  </InputLabel>
                  <Select
                    // native
                    value={tipoControle}
                    onChange={handleChangeTipoControle}
                    inputProps={{
                      name: 'tipoControle',
                      id: 'tipoControle-simple',
                    }}
                  >
                    <MenuItem value={10}>Ambiente</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                  </Select>
                </S.WrapperFormControl>
              </S.WrapperSelect>
            </S.WrapperHeader>
          </S.Wrapper>
        ) : (
          ''
        )}

        {tipoControle === 10 ? (
          <Tabela
            title={t('s.operacao.turno.estoquecontabil')}
            cells={cellStock}
            data={estoques}
            size="small"
          />
        ) : (
          <Tabela
            title={t('s.operacao.turno.estoquecontabil20')}
            cells={cellStock20}
            data={estoques}
            size="small"
          />
        )}

        {/* <Tabela
          title={t('s.operacao.turno.estoquecontabil')}
          cells={cellStock}
          data={estoques}
          size="small"
        /> */}

        {estoquesAreia.length > 0 && (
          <Tabela
            title={t('s.menu.operacao.estoqueareia')}
            cells={cellEstoqueAreia}
            data={estoquesAreia}
            size="small"
          />
        )}
      </S.WrapperGrid>

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title={labelButton}
        component={Form}
        onClose={handleCallbackOnCloseModal}
        maxWidth="md"
        fullScreen={window.innerWidth <= 450}
        toggleMonitor={setMonitorStatus}
      />
    </S.Wrapper>
  );
}
